module.exports = __webpack_public_path__ + "314260c16eac7a76cd4c045e75cc6d5f.png";